import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/axelerate-logo-purple.svg'
import _imports_1 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-12" }
const _hoisted_4 = { class: "flex flex-row justify-between items-start mb-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-6"
}, null, -1)
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, " Please create an account to save your information ", -1)
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "mb-8" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_PasswordField = _resolveComponent("PasswordField")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  disabled: _ctx.isLoading
                }, _hoisted_8, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("form", {
                  onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                  class: "mt-4"
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_TextField, {
                      name: "first_name",
                      label: "First name",
                      typeInput: "text"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_TextField, {
                      name: "last_name",
                      label: "Last name",
                      typeInput: "text"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_TextField, {
                      name: "email",
                      label: "Email",
                      typeInput: "text"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_PasswordField, {
                      name: "password",
                      label: "Password",
                      typeInput: "password"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_PasswordField, {
                      name: "password_confirmation",
                      label: "Confirm password",
                      typeInput: "text"
                    })
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _ctx.isLoading,
                    class: _normalizeClass(["w-full", {
                  'btn-filled-lg': !_ctx.isLoading,
                  'btn-filled-lg-loading': _ctx.isLoading,
                }])
                  }, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Loading..."))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, "Create an account"))
                  ], 10, _hoisted_16)
                ], 32)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19))
      : _createCommentVNode("", true)
  ]))
}